module.exports = __webpack_public_path__ + "static/img/dl_facebook.b2b4712a.png";